import withTheme from './hoc/withTheme';
import React from 'react';
import { Header } from 'semantic-ui-react';

const Logo = ({ theme }) => (
  <Header inverted={theme.isDark}>5050 System</Header>
);

export default withTheme(Logo);
